"use client"

import { getFixedT } from "@/languages/i18n"
import { Download, Home, Maximize2, Minimize2, Share2 } from "lucide-react"
import Link from "next/link"
import { LeafletItem } from "./types"
import { LetakResponseDataObject } from "@/types/codegen/data-contracts"
interface LeafletSidebarProps {
    locale: string
    isFullscreen: boolean
    showShareModal: boolean
    currentItem: LetakResponseDataObject | null
    onFullscreen: () => void
    onDownload: () => void
    onShare: () => void
    variant?: "default" | "detail"
}

export const LeafletSidebar = ({
    locale,
    isFullscreen,
    showShareModal,
    currentItem,
    onFullscreen,
    onDownload,
    onShare,
    variant = "default",
}: LeafletSidebarProps) => {
    const t = getFixedT(locale)
    const isDetail = variant === "detail"
    const baseClasses = isDetail
        ? `sm:flex hidden w-[3.2rem] shrink-0 bg-[#18af4e] flex-col items-center self-start overflow-auto ${isFullscreen ? 'opacity-0 hover:opacity-100 transition-opacity' : ''}`
        : "fixed left-0 top-0 h-screen w-16 bg-[#00A651] flex flex-col items-center z-50"

    return (
        <div className={baseClasses}>
            {isDetail ? (
                <Link href={`/${locale}`} className="w-full py-[14px] text-center text-white font-black text-base hover:bg-[#28e66d]">TDF</Link>
            ) : (
                <>
                    <div className="text-white font-bold text-base">TDF</div>
                    <Link
                        href="/"
                        className="w-10 h-10 flex items-center justify-center text-white hover:bg-[#008a43] rounded transition-all duration-300"
                        title={t("Home")}
                    >
                        <Home className="w-6 h-6" />
                    </Link>
                </>
            )}

            <button
                onClick={onFullscreen}
                className="w-full py-[14px] flex items-center justify-center text-white hover:bg-[#28e66d] transition-colors"
                title={t("Fullscreen")}
            >
                {isFullscreen ? (
                    <Minimize2 className="w-6 h-6" />
                ) : (
                    <Maximize2 className="w-6 h-6" />
                )}
            </button>

            <button
                onClick={onDownload}
                className="w-full py-[14px] flex items-center justify-center text-white hover:bg-[#28e66d] transition-colors"
                title={t("Download")}
                disabled={!currentItem}
            >
                <Download className="w-6 h-6" />
            </button>

            <button
                onClick={onShare}
                className={`w-full py-[14px] flex items-center justify-center text-white hover:bg-[#28e66d] transition-colors ${showShareModal ? 'bg-[#28e66d]' : ''}`}
                title={t("Share")}
                disabled={!currentItem}
            >
                <Share2 className="w-6 h-6" />
            </button>
        </div>
    )
}

